<script>
  export default {
    name: 'ModalCoupon',
    props: ['next', 'sign', 'accept', 'name'],
    data() {
      return {
        isModalVisible: false,
        //nextURL: "",
        //signURL: "",
        //acceptURL: "",
      }
    },
    methods: {
      closeYes() {
        $("#apply-form").submit();
        this.$emit('close');
      },
      closeNo() {
        $("#negotiation_program_code")[0].value = ""
        this.$emit('close');
      }
    },
  };
</script>

<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="color:black;text-align:center;">
          <slot name="body">
            <h5>{{ $t('javascript.modal.would_you_mind') }}</h5>
          </slot>
         </div>

        <div class="modal-footer" style="text-align: center;">
          <button
            type="button"
            class="btn btn-primary btn-nomargin"
            @click="closeNo"
          >
            {{ $t('javascript.modal.close_no') }}
          </button>

          <button
            type="button"
            class="btn btn-primary btn-nomargin"
            @click="closeYes"
          >
            {{ $t('javascript.modal.close_yes') }}
          </button>
          <br>

        </div>
      </div>
    </div>
  </div>
</template>


